
import {computed, defineComponent, onMounted, ref} from 'vue';
import Pagination from '@/components/Pagination.vue';
import { IQuiz } from '@/types/quiz';
import { routeQuestion } from '@/core/constants';
import {
  apiGetQuiz,
  GetQuizRequestFiltersPayload,
  searchQuizApi
} from '@/api/QuizApi';
import {useRoute, useRouter} from 'vue-router';
import QuizFilters from "@/components/QuizFilters.vue";
import {useStore} from 'vuex';
import {key} from '@/store';
import BaseButton from '@/components/BaseButton.vue';
import { apiRemoveQuestionNew} from '@/api/QuestionApi';
import TheModal from '@/components/TheModal.vue';
import DocumentCardCheckbox from '@/components/DocumentCardCheckbox.vue';
import ConfirmDeleteModal from '@/components/ConfirmDeleteModal.vue';
import useModal from '@/hooks/useModal';
import useBusinessFunctionId from '@/hooks/useBusinessFunctionId';

export default defineComponent({
  name: 'QuestionSelectDeletePartners',
  components: {
    ConfirmDeleteModal,
    QuizFilters,
    DocumentCardCheckbox,
    Pagination,
    BaseButton,
    TheModal,
  },
  setup() {

    const route = useRoute();
    const router = useRouter();
    const store = useStore(key);

    const confirmDeleteModal = useModal(false);

    const questionToDelete = computed(() => store.state.deleteQuestion.question);
    const savedQuizIds = computed(() => store.state.createQuestion.quizIds);
    const quizPayload = computed(() => store.state['getQuizPayload'])

    const {
      params: { id },
    } = route;
    const quizId = parseInt(id.toString(), 10);
    const name = ref('');
    const color = ref(1);
    const questionCreateConfirmIsOpen = ref(false);
    const documents = ref<IQuiz[]>([]);
    const pageMeta = ref({
      current_page: null,
      last_page: null,
      from: null,
      to: null,
      total: null,
    });
    const businessFunctionId = useBusinessFunctionId();

    onMounted(() => {
      apiGetQuiz(quizId).then((res: IQuiz | any) => {
        name.value = res.name;
        color.value = res.color;
      });
    })

    const handleQuizResponse = (res: any) => {
      documents.value = res.data.data;
      pageMeta.value = res.data.meta;
    };

    const getQuizzes = (page = 1) => {
      const payload = {
        ...quizPayload.value,
        page,
      }
      if(questionToDelete.value?.id) {
        if(!!payload.filter) {
          payload['filter']['question_id_name'] = questionToDelete.value.id;
        } else {
          payload['filter'] = {
            question_id_name: questionToDelete.value.id,
            question_ids: {}
          }
        }
      }
      store.commit('setQuizPayload', payload);
      searchQuizApi(payload).then(handleQuizResponse);
    };
    onMounted(() => {
      const payload = {
        ...quizPayload.value,
      };
      if(questionToDelete.value?.id) {
        if(!!payload.filter) {
          payload['filter']['question_id_name'] = questionToDelete.value.id;
        } else {
          payload['filter'] = {
            question_id_name: questionToDelete.value.id,
            question_ids: {}
          }
        }
      }
      searchQuizApi(payload).then(handleQuizResponse);
      store.commit('quizIdsToggle', quizId);
    });
    const toggleQuiz = (quizIdValue: number) => {
      const isCurrentQuizToggled = quizIdValue === quizId;
      if(isCurrentQuizToggled) return
      store.commit('quizIdsToggle', quizIdValue);
    };
    const handleSearch = (searchInputValue: string): void => {
      const payload = {
        ...quizPayload.value,
        name: searchInputValue,
        page: 1,
      }
      if(questionToDelete.value?.id) {
        if(!!payload.filter) {
          payload['filter']['question_id_name'] = questionToDelete.value.id;
        } else {
          payload['filter'] = {
            question_id_name: questionToDelete.value.id,
            question_ids: {}
          }
        }
      }
      store.commit('setQuizPayload', payload)

      searchQuizApi(payload).then(handleQuizResponse);
    };
    const navigateToPage = (page: number) => {
      getQuizzes(page);
    };

    function onFilterChange(data: GetQuizRequestFiltersPayload) {
      const payload = {
        ...quizPayload.value,
        ...data,
        page: 1,
      }
      if(questionToDelete.value?.id) {
        if(!!payload.filter) {
          payload['filter']['question_id_name'] = questionToDelete.value.id;
        } else {
          payload['filter'] = {
            question_id_name: questionToDelete.value.id,
            question_ids: {}
          }
        }
      }
      store.commit('setQuizPayload', payload);
      searchQuizApi(payload).then(handleQuizResponse);
    }

    function deleteNow() {

      if(!questionToDelete.value) throw new Error("Question doesn't exist");

      apiRemoveQuestionNew(quizId, questionToDelete.value.id, savedQuizIds.value)
        .then(() => {
          confirmDeleteModal.close();
          questionCreateConfirmIsOpen.value = true;
          store.commit('setCreatedQuestionInitialState');
          store.commit('setInitiateDeleteQuestion', {
            isDeleteQuestionOpen: false,
            question: null,
            questionPositionIndex: null,
            isSaveNowQuestionLocationOpen: false,
            quizIds: [],
          });
          store.commit('setQuestionEditMode', false);
        })

    }

    function cancel() {
      store.commit('quizIdsSet', []);
      router.push({
        name: routeQuestion,
        params: {
          id: quizId,
        },
      });
    }

    function selectAll() {
      store.commit('quizIdsAdd', documents.value.map(el => el.id));
    }
    function deselectAll() {
      store.commit('quizIdsOmit', documents.value.map(el => el.id));
      store.commit('quizIdsToggle', quizId);
    }
    return {
      documents,
      handleSearch,
      navigateToPage,
      pageMeta,
      onFilterChange,
      businessFunctionId,

      deleteNow,
      cancel,

      questionCreateConfirmIsOpen,
      savedQuizIds,
      toggleQuiz,

      selectAll,
      deselectAll,

      confirmDeleteModal,
    };
  },
});
